import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductCategory } from 'src/app/common/ProductCategory';
import { ApiServiceBase } from './ApiServiceBase';

@Injectable({
  providedIn: 'root'
})
export class ProductCategoryService extends ApiServiceBase {
  protected readonly path = 'productcategory';
  
  get(): Observable<ProductCategory[]> {
    return this.http.get<ProductCategory[]>(this.getUrl());
  }
}
